var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars)},[((_vm.cms.filter || []).length > 0)?_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__filter-list`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 2, x: 1, width: 24 },
      ]}},_vm._l((_vm.cms.filter),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:index,tag:"component",class:`${_vm.name}__filter`,attrs:{"cms":item},on:{"onLatestFilterClick":_vm.onLatestFilterClick}})}),1)],1):_vm._e(),_vm._v(" "),_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('fetch-story',{attrs:{"route":_vm.cms.api_endpoint || 'en-gb/thinking',"params":{
          sort_by: _vm.cms.api_order || null,
          by_uuids: _vm.cms.api_filter || null,
        },"limit":parseInt(_vm.cms.api_limit) || 0,"offset":parseInt(_vm.cms.api_offset) || 0,"collection":_vm.cms.collection,"entry":"content"},scopedSlots:_vm._u([{key:"default",fn:function({ loading, collection }){return _c('div',{class:[`${_vm.name}__cards`]},[(loading)?_c('div',{class:[`${_vm.name}__loader`]},[_c('a-canvas-bars')],1):_vm._l((_vm.filteredCollection(collection)),function(item,index){return _c('div',{key:index},_vm._l((item.thumbnails),function(thumb,t_index){return _c('m-card-narrow',{key:t_index,class:[`${_vm.name}__card`],attrs:{"cms":thumb,"published":item.first_published_at,"url":item.url}})}),1)})],2)}}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }